export default __webpack_public_path__ + "device_always_home_cam.51b9723c.png";